import { DatePipe } from '@angular/common';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseGenerateExcelOutputData } from 'app/consulta-mark-list/interface/response-generate-excel';
import { SharedGenerateExcel } from 'app/consulta-mark-list/service/BehaviorSubject/sharedGenerateExcel.service';
import { StatusPersonBehaviorSubjectService } from 'app/consulta-mark-list/service/BehaviorSubject/statusPersonBehaviorSubject.service';
import { ValidatorPerson } from 'app/consulta-mark-list/service/Validators/validator-person.service';
import { ConsultaMarkListService } from 'app/consulta-mark-list/service/consulta-mark-list.service';
import { AuthService } from 'base-angular-avla';
import { AvlaRestClientService } from 'base-angular-avla/avla-rest-client.service';
import { GenericTableAvlaService } from 'generic_table_avla_front_components';
import { AvlaGenericComponent } from 'shared-angular-components-avla';
import { MessageService } from 'shared-angular-components-avla/message-notification.service';

var b64toBlob = require('b64-to-blob');
declare var $: any;

@Component({
  selector: 'app-ml-generate-excel',
  templateUrl: './ml-generate-excel.component.html',
  styleUrls: ['./ml-generate-excel.component.css'],
})
export class MlGenerateExcelComponent
  extends AvlaGenericComponent
  implements OnInit
{
  url: string = '';
  dniPersonByGenerateExcel: string = '';
  namePersonByGenerateExcel: string = '';

  constructor(
    protected validatorPersonService: ValidatorPerson,
    protected restClientService: AvlaRestClientService,
    protected messageService: MessageService,
    protected router: Router,
    protected authService: AuthService,
    protected datePipe: DatePipe,
    protected renderer: Renderer2,
    protected marklistservice: ConsultaMarkListService,
    protected genericTableAvlaService: GenericTableAvlaService
  ) {
    super(restClientService, messageService, router, authService);
  }

  ngOnInit(): void {}

  generate($event) {
    this.marklistservice
      .generateExcelFromBack(
        this.dniPersonByGenerateExcel,
        this.namePersonByGenerateExcel
      )
      .subscribe(data => {
        this.loadExecutionProcessFile(data);
      });
  }

  loadExecutionProcessFile(id: any) {
    this.marklistservice.getProcessStatus(id).subscribe(data => {
      if (data.status == 2) {
        setTimeout(() => {
          this.loadExecutionProcessFile(data.id);
        }, 500);
      } else if (data.status == 3) {
        let responseOutput: ResponseGenerateExcelOutputData = JSON.parse(
          data.output_data
        );
        this.url = responseOutput.urlFile;

        let filename = 'mark_list_AVLA ' + this.datePipe.transform(Date.now());
        let a = $("<a style='display: none;'/>");
        a.attr('href', this.url);
        a.attr('download', filename);
        $('body').append(a);
        a[0].click();
        window.URL.revokeObjectURL(this.url);
        a.remove();
      }
    });
  }
}
